import React from 'react';
import { useTranslation } from 'react-i18next';


function StatCard({ label, value, icon, color }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-2.5 sm:p-4 hover:shadow-md transition-shadow relative min-h-[76px] sm:min-h-[90px] min-w-0 h-full pr-9 sm:pr-14">
      <p className="text-gray-500 text-[11px] sm:text-sm font-medium leading-snug break-words pr-1">{label}</p>
      <p className="text-sm sm:text-lg xl:text-xl font-bold text-gray-900 mt-1 break-words">{value}</p>
      <div className={`p-1.5 sm:p-2 absolute rounded-lg right-2 bottom-2 sm:right-3 sm:bottom-3 ${color}`}>
        {icon}
      </div>
    </div>
  );
}

export default StatCard;
